export const FINISH_ON_BOARDING_KEY = 'finish_on_boarding';
export const REPORT_PROGRESS_KEY = 'report_progress';
export const ALLOWED_PROTECTED_VIEWS_KEY = 'allowed_protected_views';
